import React from 'react';
import { SystemDiagram } from '../components/SystemDiagram';
export function SystemPage() {
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 flex flex-col items-center justify-center p-4 sm:p-8 pt-20 sm:pt-8" data-id="element-1271" data-mp="2s04xon9z4qkf">
      <div className="w-full max-w-7xl" data-id="element-1272" data-mp="2n1lbclrgxcrj">
        <div className="text-center mb-6 sm:mb-8" data-id="element-1273" data-mp="2i2iidzoriwzx">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4" data-id="element-1274" data-mp="2i3tldxadw0pz">
            The HIRE System
          </h1>
          <p className="text-base sm:text-xl text-slate-400" data-id="element-1275" data-mp="3aqweub07dl9d">
            Visual breakdown of our recruiting system architecture
          </p>
        </div>

        <div className="w-full bg-slate-900/50 rounded-xl border border-slate-800 p-2 sm:p-4 shadow-2xl" data-id="element-1276" data-mp="35q8daveclm0w">
          <div className="w-full h-[600px] md:h-[700px] lg:h-[800px] rounded-lg overflow-hidden bg-[#0A0F1C]" data-id="element-1277" data-mp="31py99oa495oo">
            <SystemDiagram data-id="element-1278" data-mp="1uajsoaokgz39" />
          </div>
        </div>
      </div>
    </div>;
}